import React, { useState } from "react";
import { Helmet } from "react-helmet";
import GenerateHomePageLinks from "../HomePageLinks/HomePageLinks";
import { MASTER_JOB_LABELS } from "../config/masterJobsApi";

const admissionTips = [
  "Review eligibility, required documents, and application schedule before applying.",
  "Check whether the process includes entrance exams, merit lists, or counseling.",
  "Keep copies of registration details and submission receipts for later stages.",
];

const AdmissionPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="page-container">
      <Helmet>
        <title>{`Free Admission Updates ${new Date().getFullYear()} | AAMSchool`}</title>
        <link rel="canonical" href="https://www.aamschool.in/admission" />
        <meta
          name="description"
          content="Find free admission form updates, entrance notices, and application alerts for students on AAMSchool."
        />
        <meta property="og:title" content={`Free Admission Updates ${new Date().getFullYear()} | AAMSchool`} />
        <meta
          property="og:description"
          content="Find free admission form updates, entrance notices, and application alerts for students on AAMSchool."
        />
        <meta property="og:url" content="https://www.aamschool.in/admission" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Admission Form {new Date().getFullYear()}</h1>
      <p className="page-lead">
        This page highlights admission-related updates for students who are tracking new forms,
        entrance notices, and application schedules. It helps users discover current opportunities
        faster and prepare documents before deadlines arrive.
      </p>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search jobs, admit card, result..."
          className="global-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <GenerateHomePageLinks
        label={MASTER_JOB_LABELS.admission}
        header="Latest Admissions"
        searchTerm={searchTerm}
        showAllItems
        layoutVariant="page"
      />

      <section className="page-info-grid" aria-label="Admission guidance">
        <article className="page-info-card">
          <h2>Admission Checklist</h2>
          <ul className="page-info-list">
            {admissionTips.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="page-info-card">
          <h2>How This Page Helps</h2>
          <p>
            Admission notices are easier to track when they are grouped clearly. This page supports
            students during the discovery stage, but final decisions should always be made after
            reading the official brochure or admission notice.
          </p>
        </article>
      </section>
    </div>
  );
};

export default AdmissionPage;
